import { axios } from "..";
import { IGuestSpeaker } from "../interfaces/models/IGuestSpeaker";

export const getGuestSpeakers = async (): Promise<IGuestSpeaker[]> => {
  try {
    const response = await axios.Get("./guestSpeaker");
    return response.data;
  } catch (error) {
    return [];
  }
};

export const getGuestSpeakerById = async (id: string): Promise<IGuestSpeaker | null> => {
  try {
    const params = new URLSearchParams();
    params.append(
      "filter",
      JSON.stringify({ id: { value: id, comparisonType: "EQUAL" } })
    );
    const response = await axios.Get(`./guestSpeaker?${params.toString()}`);
    return Array.isArray(response.data) ? response.data[0] : response.data;
  } catch (error) {
    return null;
  }
};

export const createGuestSpeaker = async (guestSpeaker: IGuestSpeaker): Promise<IGuestSpeaker> => {
  try {
    const response = await axios.Post("./guestSpeaker", guestSpeaker);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateGuestSpeaker = async (guestSpeaker: IGuestSpeaker): Promise<IGuestSpeaker> => {
  try {
    const response = await axios.Put(`./guestSpeaker`, guestSpeaker);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteGuestSpeaker = async (id: string): Promise<any> => {
  try {
    const response = await axios.Delete(`./guestSpeaker`, `${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getGuestSpeakersByCompany = async (companyId: string): Promise<IGuestSpeaker[]> => {
  try {
    const params = new URLSearchParams();
    params.append(
      "filter",
      JSON.stringify({ company: { value: companyId, comparisonType: "EQUAL" } })
    );
    const response = await axios.Get(`./guestSpeaker?${params.toString()}`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error("Error fetching guest speakers by company:", error);
    return [];
  }
};

export const getNotRegisteredGuestSpeakers = async (
  companyId: string,
  eventId: string
): Promise<IGuestSpeaker[]> => {
  try {
    const params = new URLSearchParams();
    params.append("action", "getUnregisteredByCompanyAndEvent");
    params.append("companyId", companyId);
    params.append("eventId", eventId);

    const response = await axios.Get(`./guestSpeaker?${params.toString()}`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error("Error fetching guest speakers by company:", error);
    return [];
  }
};

